import React, { Component } from "react";
import Button from "../components/Button";
import { randomArrayElement } from "../utils/random";
import GameSetting from "./../config/gameChoiceReaction";
import Howtoplay from "../components/Howtoplay";
import Waiting from "../components/Waiting";
import Passpracetice from "../components/Passpracetice";
import Game from "../containers/Game";
import StatusGame from "../components/StatusGame";
import Umbrella from "../components/Umbrella";
import styles from "./gamechoicereaction.module.css";
import { color, GameData } from "../containers/GameContainer";
import IntroGame from "../components/IntroGame";
import ButtonNextLevel from "../components/ButtonNextLevel";
import ButtonNextGame from "../components/ButtonNextGame";
import { useData } from "../contexts/DataContext";
import CountdownTimer from "../components/CountdownTimer";
import ButtonGreen from "../components/ButtonGreen";
import LevelResult from "../components/LevelResult";

const QuestionPool = ["red", "blue", "green"];

class GameChoiceReaction extends Component {
  constructor() {
    super();

    // game loop
    this.animationID = null;
    this.lastUpdate = null;
    this.questionShowAt = null;

    // game state
    this.state = {
      id: "1",
      showIntro: true,
      showHowtoplay: false,
      showLevel: false,
      passLevel: false,
      action: "cooldown",
      level: 0,
      round: 0,
      result: Array(GameSetting.level.length).fill([]),
      question: null,
    };
  }

  restartGame() {
    this.setState({
      showIntro: false,
      showHowtoplay: true,
      level: 0,
      round: 0,
      result: Array(GameSetting.level.length).fill([]),
    });
  }

  startGame() {
    this.setState({
      showHowtoplay: false,
      showLevel: false,
    });
    this.animationID = requestAnimationFrame((now) => this.gameLoop(now));
  }

  showHowtoPlay() {
    this.setState({
      showIntro: false,
      showHowtoplay: true,
    });
  }

  gameLoop(now) {
    if (!this.lastUpdate) {
      this.lastUpdate = now;
    }

    const delta = now - this.lastUpdate;
    const levelSetting = GameSetting.level[this.state.level];

    switch (this.state.action) {
      case "cooldown":
        if (delta > levelSetting.cooldownTime) {
          this.setState({
            question: randomArrayElement(QuestionPool),
            action: "play",
          });
          this.lastUpdate = now;
        }
        break;

      case "play":
        if (delta > levelSetting.displayTime) {
          this.nextRound("timeout");
          this.lastUpdate = now;
        }
        break;

      default:
    }

    if (this.animationID) {
      this.animationID = requestAnimationFrame((now) => this.gameLoop(now));
    }
  }

  nextRound(roundResult, responseTime = 0) {
    const levelSetting = GameSetting.level[this.state.level];

    this.setState(
      (state) => ({
        question: null,
        action: "cooldown",
        result: Object.assign([], state.result, {
          [this.state.level]: [
            ...state.result[this.state.level],
            { result: roundResult, responseTime },
          ],
        }),
      }),
      () => {
        if (this.state.round === levelSetting.round - 1) {
          // next level
          this.nextLevel();
        } else {
          // next round
          this.setState((state) => ({
            round: state.round + 1,
          }));
        }
      }
    );
  }

  clickAnswer(ans) {
    // clear timer, so it doesn't wait for displayTime
    this.lastUpdate = null;

    const now = new Date();
    this.nextRound(
      ans === this.state.question ? "correct" : "wrong",
      now - this.questionShowAt
    );
  }

  nextLevel() {
    const levelSetting = GameSetting.level[this.state.level];
    cancelAnimationFrame(this.animationID);
    this.animationID = null;
    this.lastUpdate = null;

    const levelScore =
      levelSetting.score *
      this.state.result[this.state.level].reduce(
        (sum, cur) => sum + (cur.result === "correct" ? 1 : 0),
        0
      );

    this.setState((state) => ({
      round: 0,
      level: state.level + 1,
      showLevel: true,
      passLevel: levelScore >= (levelSetting.passScore ?? 0),
    }));
  }

  nextGame() {
    this.props.submitResult(this.state.id, this.state.result);
    let data = {
      [this.state.id]: this.state.result
        .filter((result, index) => index !== 0 && result.length > 0) 
        .map(result => 
          result.map((answer,no) => ({
            no,
            result: answer.result,
            responseTime: answer.responseTime
          }))
        )
    };
    this.props.updateAllResult(data);
    this.props.navigateNextPage();
  }

  componentDidUpdate(_, prevState) {
    if (
      prevState.action !== this.state.action &&
      this.state.action === "play"
    ) {
      this.questionShowAt = new Date();
    }
  }

  render() {
    const levelSetting = GameSetting.level[this.state.level];
    const score_default = GameSetting.level[1].score;

    if (this.state.showIntro) {
      return (
        <IntroGame icon={GameData[0].gamePic} headname="เกมทดสอบที่ 1 :">
          <Button onClick={() => this.showHowtoPlay()}>ทำการทดสอบ</Button>
        </IntroGame>
      );
    }

    if (this.state.showHowtoplay) {
      return (
        <div>
          <Howtoplay id={this.state.id} />
          <ButtonGreen onClick={() => this.startGame()}>ทดลองเล่น</ButtonGreen>
        </div>
      );
    }
    if (this.state.showLevel) {
      const levelScore =
        score_default *
        this.state.result[this.state.level - 1].reduce(
          (sum, cur) => sum + (cur.result === "correct" ? 1 : 0),
          0
        );
      const prevLevelSetting = GameSetting.level[this.state.level - 1];
      const totalmilliTime = this.state.result[this.state.level - 1].reduce(
        (sum, item) => {
          const responseTime =
            item.responseTime === 0
              ? prevLevelSetting.displayTime
              : item.responseTime;
          return sum + responseTime;
        },
        0
      );
      const totalTime = (
        totalmilliTime /
        prevLevelSetting.round /
        1000
      ).toFixed(2);

      return (
        <div className={styles.passpracetice}>
          {prevLevelSetting.practice ? (
            <>
              {this.state.passLevel ? (
                <Passpracetice pass={this.state.passLevel}>
                  คุณผ่านการทดลองเล่นแล้ว ต่อไปคือการทดสอบจริง
                </Passpracetice>
              ) : (
                <>
                  <Passpracetice pass={this.state.passLevel}>
                    คุณยังไม่ผ่านการทดลองเล่น ต้องการทดลองเล่นเกมนี้อีกครั้งไหม
                  </Passpracetice>
                  <Button onClick={() => this.restartGame()}>
                    ทดลองเล่นอีกครั้ง
                  </Button>
                </>
              )}
            </>
          ) : (
            <>
              {this.state.passLevel ? (
                <>
                  <StatusGame status={"Pass"}>
                    ยินดีด้วย
                    <br />
                    คุณผ่านการทดสอบ
                    {prevLevelSetting.name} แล้ว
                    <br />
                    มาทดสอบระดับต่อไปกัน
                  </StatusGame>
                  <LevelResult
                    name={"Choice reaction time test"}
                    score={levelScore}
                    fullscore={prevLevelSetting.round}
                    time={totalTime}
                  />
                </>
              ) : (
                <>
                  <StatusGame status={"Fail"}>
                    คุณไม่ผ่านการทดสอบ
                    <br />
                    ไม่ต้องเสียใจนะ<br></br>
                    ยังมีเกมที่ 2 รอคุณอยู่
                  </StatusGame>
                  <LevelResult
                    name={"Choice reaction time test"}
                    score={levelScore}
                    fullscore={prevLevelSetting.round}
                    time={totalTime}
                  />
                </>
              )}
            </>
          )}
          {(this.state.passLevel &&
            this.state.level < GameSetting.level.length) ||
          prevLevelSetting.practice ? (
            <ButtonNextLevel
              onClick={() => this.startGame()}
              Nextlevel={this.state.level}
            >
              {prevLevelSetting.practice
                ? this.state.passLevel
                  ? "เริ่มการทดสอบ"
                  : "ไม่ ฉันต้องการไปเริ่มทำการทดสอบ"
                : "ทดสอบ"}
            </ButtonNextLevel>
          ) : (
            <ButtonNextGame onClick={() => this.nextGame()}>
              ทดสอบเกมต่อไป
            </ButtonNextGame>
          )}
        </div>
      );
    }

    return (
      <>
        {this.state.action === "play" ? (
          <div className={styles.body}>
            <div className={styles.timer}>
              <CountdownTimer initialTime={levelSetting.displayTime} />
            </div>
            <Game
              name={levelSetting.name}
              round={this.state.round}
              levelRound={levelSetting.round}
              id={this.state.id}
              headq={`กรุณาเลือกคำตอบ`}
            >
              <div className={styles.umbrella}>
                <Umbrella color={color[this.state.question]}></Umbrella>
              </div>
              <div className={styles.flexrow}>
                <div
                  className={styles.buttonred}
                  onClick={() => this.clickAnswer("red")}
                >
                  1
                </div>

                <div
                  className={styles.buttonblue}
                  onClick={() => this.clickAnswer("blue")}
                >
                  2
                </div>

                <div
                  className={styles.buttongreen}
                  onClick={() => this.clickAnswer("green")}
                >
                  3
                </div>
              </div>
            </Game>
          </div>
        ) : (
          <Waiting />
        )}
      </>
    );
  }
}

const WrapperGameChoiceReaction = (props) => {
  const { id, updateAllResult } = useData();

  return (
    <GameChoiceReaction
      guid={id}
      updateAllResult={updateAllResult}
      {...props}
    />
  );
};

export default WrapperGameChoiceReaction;
